"use strict";

module.exports = {
    "postbox-text": "Tulis komentar di sini (minimal 3 karakter)",
    "postbox-author": "Nama (opsional)",
    "postbox-author-placeholder": "Budi",
    "postbox-email": "Email (opsional)",
    "postbox-email-placeholder": "budi@example.com",
    "postbox-website": "Situs web (opsional)",
    "postbox-website-placeholder": "https://example.com/",
    "postbox-preview": "Pratinjau",
    "postbox-edit": "Edit",
    "postbox-submit": "Kirim",
    "postbox-notification": "Dapatkan notifikasi balasan lewat email",

    "num-comments": "Satu komentar\n{{ n }} komentar",
    "no-comments": "Belum ada komentar",
    "atom-feed": "Feed Atom",

    "comment-reply": "Balas",
    "comment-edit": "Edit",
    "comment-save": "Simpan",
    "comment-delete": "Hapus",
    "comment-confirm": "Konfirmasi",
    "comment-close": "Tutup",
    "comment-cancel": "Batal",
    "comment-deleted": "Komentar dihapus.",
    "comment-queued": "Komentar menunggu moderasi.",
    "comment-anonymous": "Anonim",
    "comment-hidden": "{{ n }} disembunyikan",
    "comment-page-author-suffix": "Penulis",

    "date-now": "baru saja",
    "date-minute": "1 menit yang lalu\n{{ n }} menit yang lalu",
    "date-hour": "1 jam yang lalu\n{{ n }} jam yang lalu",
    "date-day": "kemarin\n{{ n }} hari yang lalu",
    "date-week": "1 minggu lalu\n{{ n }} minggu lalu",
    "date-month": "1 bulan lalu\n{{ n }} bulan lalu",
    "date-year": "1 tahun lalu\n{{ n }} tahun lalu"
};
